import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["list", "selected", "input"];

  connect() {
    this.updateSelectedLabel();
    this._outsideClickHandler = (event) => {
      if (!this.element.contains(event.target)) {
        this.listTarget.classList.add("hidden");
      }
    };
    document.addEventListener('click', this._outsideClickHandler);
  }

  disconnect() {
    document.removeEventListener('click', this._outsideClickHandler);
  }

  toggle(event) {
    event.preventDefault();
    this.listTarget.classList.toggle("hidden");
  }

  filter(event) {
    const query = event.target.value.toLowerCase();
    this.listTarget.querySelectorAll('label').forEach(label => {
      const text = label.textContent.toLowerCase();
      label.style.display = text.includes(query) ? '' : 'none';
    });
  }

  update() {
    this.updateSelectedLabel();
  }

  updateSelectedLabel() {
    const checked = Array.from(this.listTarget.querySelectorAll('input[type=checkbox]:checked'));
    const names = checked.map(cb => cb.parentElement.textContent.trim());
    this.selectedTarget.textContent = names.length ? names.join(', ') : this.selectedTarget.dataset.placeholder;
  }

  selectAll() {
    this.listTarget.querySelectorAll('input[type=checkbox]').forEach(cb => {
      cb.checked = true;
    });
    this.updateSelectedLabel();
  }

  selectNone() {
    this.listTarget.querySelectorAll('input[type=checkbox]').forEach(cb => {
      cb.checked = false;
    });
    this.updateSelectedLabel();
  }
}
